import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import SectionHeader from '../SectionHeader/SectionHeader';
import ParagraphWithImage from './ParagraphWithImage';
import { headerWithDescType } from 'src/types';

function BlocksWithImage({ paragraphsWithImage, sectionHeader: { title, tagline, description } }) {
  return (
    <Container as="section" className="py-5">
      <SectionHeader title={title} tagline={tagline} description={description} />
      <Container fluid>
        <Row>
          <Col xs={12} className="py-4">
            <Row>
              {paragraphsWithImage.map((paragraph, index) => (
                <ParagraphWithImage key={index} paragraph={paragraph} isEven={index % 2 === 0} />
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

BlocksWithImage.propTypes = {
  paragraphsWithImage: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      image: PropTypes.shape({}),
      paragraphs: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  sectionHeader: headerWithDescType.propTypes,
};

BlocksWithImage.defaultProps = {
  paragraphsWithImage: [],
  sectionHeader: headerWithDescType.defaultProps,
};

export default BlocksWithImage;
